import { IImageWriter } from 'app/interfaces/IImageWriter';
import React from 'react';

const ImageWriterContext = React.createContext<IImageWriter>(undefined);

export default ImageWriterContext;
